<template>
    <div>
        <TopBar :label="lbl.topbar.label.signup" />
        <div class="page-register">
            <div class="wrapper-content">
                <div class="content-left">
                    <img class="img-cart" src="@/assets/login/cart_new.png" />
                </div>
                <div class="content-right">
                    <div class="register-form">
                        <FormRegister
                            :form="registerModel"
                            :modalController="modalController"
                            @login="login()"
                            @onSubmitRegister="onSubmit($event)">
                        </FormRegister>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>

<script>
//helper
import CacheHelper from '@/helper/CacheHelper';
import Account from "@/helper/AccountHelper.js"
//mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ModalMixin from '@/mixin/ModalMixin';
//service
import BzbsProfile from '@/core/Account/service/BzbsProfile';
import { RegisterModel } from "../model/RegisterModel";
import { AuthLoginConfigBuilder } from '@/core/Account/config/AuthConfigModel';
//component
//import SideImageDesktop from '../component/SideImageDesktop.vue';
import FormRegister from '../component/FormRegister.vue';
import TopBar from '@/components/Layout/TopBar/TopbarSignUp.vue';
import Footer from '@/components/Layout/Footer/Footer.vue';

export default {
    name: 'Register',
    mixins: [LocaleMixin, ModalMixin],
    components:{
        //SideImageDesktop,
        FormRegister,
        TopBar,
        Footer,
    },
    data() {
        return {
            paramsRegister: null,
            registerModel: new RegisterModel(),
        };
    },

    mounted() {

    },

    methods: {
        login: function(){
            this.$router.push('/login')
        },
        onSubmit: async function(data){
            this.paramsRegister = data;
            let sessionCache = new CacheHelper('session');
            let cacheData = sessionCache.getCache('pdpa');
            this.paramsRegister.dataprivacy = cacheData ? cacheData.privacy : 0; //version || false (0)
            this.paramsRegister.termandcondition = cacheData ? cacheData.terms : 0; //version || false (0)
            this.paramsRegister.marketingOption = cacheData ? cacheData.mkt : 0; //version || false (0)
            this.paramsRegister.mktoption_sms = cacheData.mkt_channel.sms ? cacheData.mkt : -1, //version || false (-1)
            this.paramsRegister.mktoption_email = cacheData.mkt_channel.email ? cacheData.mkt : -1, //version|| false (-1)

            this.loadingModal.show();
            let success = await this.validateRegisterApi();
            if(success){
                this.showOtpModal();
            }
            this.loadingModal.hide();
        },
        showOtpModal: function(){
            //set loadingModal & alertModal
            this.modalController.otpModal.setLoadingModal(this.modalController.loadingModal)
            this.modalController.otpModal.setAlertModal(this.modalController.alertModal)
            //start otp
            this.modalController.otpModal.startOtp(this.paramsRegister.contactNumber, 'register')
            this.modalController.otpModal.onSubmitOtp((otp)=>{
                this.paramsRegister.otp = otp.otp;
                this.paramsRegister.refcode = otp.refcode;
                this.registerApi();
            })
        },
        registerApi:function(){
            this.modalController.loadingModal.show();
            return new Promise((resolve) => {
                BzbsProfile.registerUserWithParams(this.paramsRegister.getParams()).subscribe((data) => {
                    console.log(data)
                    this.modalController.loadingModal.hide();
                    this.modalController.otpModal.hide();
                    this.successApi();
                    resolve(true);
                }, (err) => {
                    if(err.code == 409 && err.id == 2091){
                         this.modalController.otpModal.showError(this.paramsRegister.getParams().contact_number,this.paramsRegister.getParams().refcode);
                         this.modalController.otpModal.show();
                    }else{
                        this.errorApi(err);
                    }
                    this.modalController.loadingModal.hide();
                    resolve(err);
                });
            });
        },
        validateRegisterApi: function(){
            let params = {
                 app_id: '',
                 username: this.paramsRegister.getParams().username,
                 email: this.paramsRegister.getParams().email,
                 contact_number: this.paramsRegister.getParams().contact_number,
            }
            return new Promise((resolve) => {
                BzbsProfile.apiValidateRegister(params)
                    .subscribe((data) => {
                        console.log(data)
                        resolve(true);
                    }, (err) => {
                        this.errorApi(err)
                        resolve(false);
                    });
            })
        },
        errorApi: function(err){
            this.modalController.alertModal
                .clearModal()
                .setMsg(err.message)
                .show();
        },
        successApi: function(){
            this.modalController.alertModal
                .clearModal()
                .setTitle('Register Successfully')
                .setMsg('ลงทะเบียนเข้าใช้งานสำเร็จ')
                .show();
            this.modalController.alertModal.onClickOk(async ()=>{
                this.modalController.loadingModal.show();
                await this.refreshLogin(this.paramsRegister)
                this.modalController.loadingModal.hide();
            })
        },
        refreshLogin: function(data){
            let loginParams = new AuthLoginConfigBuilder()
                    .setUsername(data.username)
                    .setPassword(data.password)
                    .create()
                    .getParams()
            Account.apiBzbsLogin(loginParams)
                .then(res => {
                    console.log(res);
                    window.location.replace('/');
                }).catch(err => {
                    console.log(err);
                    this.errorApi(err);
                });

        }
    },
};
</script>

<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import './Register.scss';
.logo-mobile{
    display: none;
    @include mobile{
        display: flex;
        padding-top:20px ;
    }
}
</style>
